import { useMemo, useEffect } from "react";
import styles from "../css/component_css/RegistrationSuccessPopup.module.css";

const RegistrationSuccessPopup = (props) => {

  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [props.open]);

  return (props.open) ? (
    <div className={styles.popUp} id="SuccessPopup">
      <div className={styles.closeWrapper}>
        <img className={styles.closeIcon} alt="" src="../close.svg" />
      </div>
      <div className={styles.contentParent}>
        <div className={styles.content}>
          <div className={styles.image}>
            <img
              className={styles.checkmarkCircleIcon}
              alt=""
              src="../checkmarkcircle23.svg"
            />
          </div>
          <div className={styles.content1}>
            <b className={styles.giThnhCng}>{props.successMessage}</b>
            <div className={styles.tinNhnCaContainer}>
              <p className={styles.thngTinNg}>{props.confirmationMessage} </p>
              <p className={styles.cmNBn}>Cảm ơn bạn!</p>
            </div>
          </div>
        </div>
        <div className={styles.buttons} onClick={()=>location.reload()}>
          <div className={styles.buttonDesktop} >
            <b className={styles.tiTrios}>OK</b>
          </div>
        </div>
      </div>
    </div>
  ) : "";
};

export default RegistrationSuccessPopup;
